// Measurement + per-client metrics hooks.
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { measurementsApi, qk } from "../api";
import type { MeasurementInput } from "../api";

export function useMeasurements(clientId: number | undefined) {
  return useQuery({
    queryKey: qk.clients.measurements(clientId ?? -1),
    queryFn: ({ signal }) =>
      measurementsApi.list(clientId as number, signal),
    enabled: clientId !== undefined && clientId >= 0,
  });
}

export function useClientMetrics(clientId: number | undefined) {
  return useQuery({
    queryKey: qk.clients.metrics(clientId ?? -1),
    queryFn: ({ signal }) =>
      measurementsApi.metrics(clientId as number, signal),
    enabled: clientId !== undefined && clientId >= 0,
  });
}

export function useAddMeasurement() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      clientId,
      body,
    }: {
      clientId: number;
      body: MeasurementInput;
    }) => measurementsApi.add(clientId, body),
    onSuccess: (_m, { clientId }) => {
      void qc.invalidateQueries({ queryKey: qk.clients.measurements(clientId) });
      void qc.invalidateQueries({ queryKey: qk.clients.metrics(clientId) });
    },
  });
}
